module.exports = __webpack_public_path__ + "static/media/hsg-logo.b9b74c55.png";